import { Component, Input } from '@angular/core';
import { Category } from '~app/modules/generic/models';

@Component({
  selector: 'app-crawlable-categories',
  templateUrl: './crawlable-categories.component.html',
  styleUrls: ['./crawlable-categories.component.scss'],
})
export class CrawlableCategoriesComponent {
  @Input() categories: Array<Category>;
}
